//=====================================================
//　診察券番号テキストボックス
//=====================================================

import { FieldValues, useFormContext, UseFormReturn } from 'react-hook-form';
import { InputTag } from '../utils/ConstCommon';
import { getMsg, ConstMsg } from '../utils/ConstMsg';
import { InputTextBase } from './InputTextBase';
import { LblInput } from './LblInput';
import { ValidErrMsgInline } from './ValidErrMsgInline';

interface IFProps {
    name: string
}

const FORM_TITLE = '診察券番号';

export function TxtLoginId(props: IFProps) {
    
    const cf = useFormContext();

    //バリデーション
    const validations = {
        required: getMsg(ConstMsg.EG0080001, [FORM_TITLE]),
        validate: {
            formatCheck1: function(){return formatCheck1(props, cf)}, //半角英数記号
            invalidCheck: function(){return invalidCheck(props, cf)}  //半角スペースチェック
        },
        maxLength: {value: 40, message: getMsg(ConstMsg.EG0080004, [FORM_TITLE, '40'])}
    }

    return (
        <div className='input-box'>
            <LblInput title={FORM_TITLE} tag={InputTag.Required} />
            <ValidErrMsgInline name={props.name}/>
            <InputTextBase name={props.name} className='input-text-card-number' validations={validations}/>
            <div className='input-supple'>
                ※診察券に記載されております「診察券番号」を入力してください。
            </div>
        </div>
    )

}
//-----------------------------------------------------
//　半角英数値形式チェック
//-----------------------------------------------------
function formatCheck1(props: IFProps, cf: UseFormReturn<FieldValues>){
	var i:number;			//カウンター
	var int_asc:number ;	//文字のアスキーコード

	// 値がない場合、終了
	if (cf.getValues(props.name) === '') {
		return null;
	}

    const val = cf.getValues(props.name);

    // 全ての文字を調べる
    for (i=0; i < val.length; i++) {
        //アスキーコード取得
        int_asc = val.charCodeAt(i);
        // 半角英数値以外の場合、エラー
        if ((0 > int_asc) || (127 < int_asc)) {
            return getMsg(ConstMsg.EG0080002, [FORM_TITLE]);
        }
    }

	// 正常
	return null;
}

//-----------------------------------------------------
//　会員番号の入力形式をチェックする。
//  半角スペースが先頭と末尾に無いこと。
//  半角スペースが２つ以上存在しないこと。
//-----------------------------------------------------
function invalidCheck(props: IFProps, cf: UseFormReturn<FieldValues>){
    let value = cf.getValues(props.name);

    if ( value.match(/^ /) ){ 
        return getMsg(ConstMsg.EG0080003, ["診察券番号"]);
    }
    if ( value.match(/ $/) ){ 
        return getMsg(ConstMsg.EG0080003, ["診察券番号"]);
    }
    //半角スペース除去
    const count = ( value.match( /[ ]/g ) || [] ).length ;
    if ( count >= 2 ){
        return getMsg(ConstMsg.EG0080003, ["診察券番号"]);
    }

    return null;
}
